// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"23f0aa45","80":"286c2db4","251":"42dccf69","406":"0a4fbf4a","443":"ead922af","453":"9e36037a","642":"1b0aa272","819":"d9bae866","891":"5ed722a4"}[chunkId] + ".chunk.js";
};